export default __webpack_public_path__ + "static/media/more-vertical.dc8b98d9.svg";